//ImageItem.js
import { lerpExp } from '../utils';

export function createImageItem(imageCache) {
  return function ImageItem(id, src, x, y, scale = 0.5) {
    const rec = imageCache.load(src);

    return {
      type: 'image',
      id,
      src,
      rec,
      x,
      y,
      scale,

      useSceneAlpha: false,

      // move state
      baseX: x,
      baseY: y,
      tx: x,
      ty: y,
      moveSpeed: 2,

      // fade state
      alpha: 1,
      targetAlpha: 1,
      fadeSpeed: 1,
      visible: true,

      setTargetPos(nx, ny) {
        this.tx = nx;
        this.ty = ny;
      },

      resetPos() {
        this.tx = this.baseX;
        this.ty = this.baseY;
      },

      draw(ctx, sceneAlpha = 1) {
        if (!rec.ready || !this.visible || this.alpha <= 0.001) return;

        const a = (this.useSceneAlpha ? sceneAlpha : 1) * this.alpha;
        if (a <= 0.001) return;

        const prevA = ctx.globalAlpha;
        if (a !== 1) ctx.globalAlpha = prevA * a;

        ctx.drawImage(
          rec.img,
          this.x,
          this.y,
          rec.w * this.scale,
          rec.h * this.scale,
        );

        if (a !== 1) ctx.globalAlpha = prevA;
      },

      update(dt) {
        const prevX = this.x;
        const prevY = this.y;
        const prevA = this.alpha;
        const prevVis = this.visible;

        this.alpha = lerpExp(this.alpha, this.targetAlpha, this.fadeSpeed, dt);

        // 꺼졌을때 draw 스킵
        if (this.alpha <= 0.001 && this.targetAlpha === 0) {
          this.visible = false;
        } else if (this.targetAlpha > 0) {
          this.visible = true;
        }

        this.x = lerpExp(this.x, this.tx, this.moveSpeed, dt);
        this.y = lerpExp(this.y, this.ty, this.moveSpeed, dt);

        return (
          Math.abs(this.x - prevX) > 1e-3 ||
          Math.abs(this.y - prevY) > 1e-3 ||
          Math.abs(this.alpha - prevA) > 1e-4 ||
          this.visible !== prevVis
        );
      },
      hitTest(px, py) {
        if (!rec.ready) return false;
        const w = rec.w * this.scale;
        const h = rec.h * this.scale;
        return (
          px >= this.x && px <= this.x + w && py >= this.y && py <= this.y + h
        );
      },
    };
  };
}
